
// import React, { Component } from "react";
// // import logo_ghoomo from '../assets/images/Ghoomoworld-black-logo-1.png';
// // ../../../assets/images/logo_ghoomo.jpeg
// /* global Razorpay */

// class MakePayment extends Component {
//   constructor(props) {
//     super(props);

//     console.log('paymentDetails:', props.paymentDetails); 
//     console.log("Received props:", props);

//     this.state = {
//       rzp1: null,
//       totalAmount: 0
//     };
//   }

//   componentDidMount() {
//     let amount = 0;
//     if (this.props.selectedOption === "full") {
//       amount = this.props.grandTotal;
//     } else if (this.props.selectedOption === "registration") {
//       amount = this.props.regAmount;
//     } else if (this.props.selectedOption === "custom") {
//       amount = this.props.customAmount;
//     }
//     // const amountInPaise = amount * 100;

//     this.setState({ totalAmount : amount * 100 });
//     this.scriptLoaded();
//   }

//   //   loadRazorpayScript = () => {
//   //     const script = document.createElement("script");
//   //     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//   //     script.async = true;
//   //     script.onload = this.scriptLoaded;
//   //     script.onerror = () => alert("Failed to load Razorpay script");
//   //     document.body.appendChild(script);
//   //   };
//   componentDidUpdate(prevProps) {
//     // Detect if amount-related props or selectedOption changed
//     if (
//       prevProps.selectedOption !== this.props.selectedOption ||
//       prevProps.grandTotal !== this.props.grandTotal ||
//       prevProps.regAmount !== this.props.regAmount ||
//       prevProps.customAmount !== this.props.customAmount
//     ) {
//       this.initializeRazorpay(); // Re-initialize with new amount
//       console.log("updated")
//       let amount = 0;
//       if (this.props.selectedOption === "full") {
//         amount = this.props.grandTotal;
//       } else if (this.props.selectedOption === "registration") {
//         amount = this.props.regAmount;
//       } else if (this.props.selectedOption === "custom") {
//         amount = this.props.customAmount;
//       }
//       // const amountInPaise = amount * 100;

//       this.setState({ totalAmount : amount * 100 });
//       // this.scriptLoaded();
//     }
//   }
//   initializeRazorpay = () => {
//     const {
//       grandTotal,
//       selectedOption,
//       regAmount,
//       customAmount,
//     } = this.props;

//     let amount = 0;
//     if (selectedOption === "full") {
//       amount = grandTotal;
//     } else if (selectedOption === "registration") {
//       amount = regAmount;
//     } else if (selectedOption === "custom") {
//       amount = customAmount;
//     }

//     const amountInPaise = amount * 100;

//     const options = {
//       key: "rzp_live_Z00fZaH51I2BAi", // Replace with your live key
//       amount: amountInPaise.toString(),
//       currency: "INR",
//       name: "Ghoomo World",
//       description: "Test Transaction",
//       handler: (response) => {
//         alert("Payment ID: " + response.razorpay_payment_id);
//         alert("Order ID: " + response.razorpay_order_id);
//         alert("Signature: " + response.razorpay_signature);
//       },
//       prefill: {
//         name: "Gaurav Kumar",
//         email: "gaurav.kumar@example.com",
//         contact: "9999999999",
//       },
//       notes: {
//         address: "Razorpay Corporate Office",
//       },
//       theme: {
//         color: "#3399cc",
//       },
//     };

//     const rzp1 = new window.Razorpay(options);

//     rzp1.on("payment.failed", (response) => {
//       console.error("Payment Failed", response.error);
//     });

//     this.setState({ rzp1});
//   };
//   scriptLoaded = () => {
//     const { grandTotal, selectedOption, regAmount, customAmount,termsAccepted } = this.props;
//     console.log("props", this.props)
//     let amount =0 ;
//     if (selectedOption === 'full') {
//       amount = grandTotal;
//     } else if (selectedOption === 'registration') {
//       amount = regAmount;
//     } else if (selectedOption === 'custom') {
//       amount = customAmount;
//     }

//     const amountInPaise = amount * 100;
//     console.log(amountInPaise);
//     const options = {
//       key: "rzp_live_Z00fZaH51I2BAi", 
//       amount: amountInPaise.toString(), 
//       currency: "INR",
//       name: "Ghoomo World",
//       description: "Test Transaction",
//       //   image: `${logo_ghoomo}`,
//       handler: (response) => {
//         alert("Payment ID: " + response.razorpay_payment_id);
//         alert("Order ID: " + response.razorpay_order_id);
//         alert("Signature: " + response.razorpay_signature);
//       },
//       prefill: {
//         name: "Gaurav Kumar",
//         email: "gaurav.kumar@example.com",
//         contact: "9999999999",
//       },
//       notes: {
//         address: "Razorpay Corporate Office",
//       },
//       theme: {
//         color: "#3399cc",
//       },
//     };

//     const rzp1 = new window.Razorpay(options);

//     rzp1.on("payment.failed", (response) => {
//       //   alert("Payment failed!");
//       //   alert(response.error.code);
//       //   alert(response.error.description);
//       //   alert(response.error.source);
//       //   alert(response.error.step);
//       //   alert(response.error.reason);
//       //   alert(response.error.metadata.order_id);
//       //   alert(response.error.metadata.payment_id);
//     });

//     this.setState({ rzp1, totalAmount : amountInPaise });
//     // this.setState({ })

//   };

//   openCheckout = () => {
//     if (this.state.rzp1) {
//       this.state.rzp1.open();
//     } else {
//       alert("Razorpay is not ready yet.");
//     }
//   };

//   render() {
//     const { totalAmount } = this.state;
//     const { termsAccepted } = this.props;
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center' }}>
//         {/* <h2>Razorpay Payment</h2> */}
//         {/* <button onClick={this.openCheckout} style={{ padding: "10px 20px" }}>
//           Make Payment
//         </button> */}
//         <button
//           className="btn btn-primary"
//           onClick={this.openCheckout}
//           style={{ backgroundColor: '#fff099', color: '#2d2b29', width: '100%', border: '1px solid #fff099' }}
//           disabled={!termsAccepted}
//         >
//           {termsAccepted
//             ? `Make Payment ₹${(totalAmount / 100).toFixed(2)}`
//             : `Make Payment ₹${(totalAmount / 100).toFixed(2)}`}
//         </button>
//       </div>
//     );
//   }
// }

// export default MakePayment;


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import environment from '../../environment/environment';
import { useNavigate } from 'react-router-dom';

function MakePayment({ paymentDetails, termsAccepted, regAmount, grandTotal, selectedTrainOption, customAmount, selectedOption }) {
  const [totalAmount, setTotalAmount] = useState(0);
  const [pendingAmount, setPendingAmount] = useState(0);
  const [userDetails, setUserDetails] = useState('');
  const [razorPayAmount,setRazorPayAmount]=useState(0);
  const [orderStatus,setOrderStatus]=useState('')
  const [paidAmount,setPaidAmount]=useState(0);
  const navigate = useNavigate();
  
  useEffect(() => {
    console.log(paymentDetails)
    let amount = 0;
    if (selectedOption === "full") {
      amount = grandTotal;
      setPendingAmount(0);
      setOrderStatus('Accepted');
      setPaidAmount(grandTotal);
    } else if (selectedOption === "registration") {
      amount = regAmount;
      setPendingAmount(grandTotal - regAmount);
      setOrderStatus('Inprogress');
      setPaidAmount(regAmount);
    } else if (selectedOption === "custom") {
      const parsedCustomAmount = Number(customAmount);
      amount = parsedCustomAmount;
      setPendingAmount(grandTotal - parsedCustomAmount);
      setPaidAmount(parsedCustomAmount);
    
      if (parsedCustomAmount === grandTotal) {
        console.log('Accepted');
        setOrderStatus('Accepted');
      } else if (parsedCustomAmount < grandTotal) {
        console.log('Inprogress');
        setOrderStatus('Inprogress');
      } 
    }
    
    setRazorPayAmount(amount);
    setTotalAmount(amount * 100);
    


    // Get and decode JWT token safely
    const token = localStorage.getItem('token');
   
    if (token) {
      try {
        // inItPayment(token);
        // createOrder(token);
        const userData = JSON.parse(token);
        setUserDetails(userData);
      } catch (error) {
        console.error("Invalid JSON token format:", error);
      }
    } else {
      console.warn("Token not found in localStorage.");
    }
    
  }, [grandTotal, regAmount, selectedOption, customAmount]);


  const createOrder = async () => {
    const requestBody={
        "amount":"1",
        "mode":"Test Mode"    
    }
    const result = await axios.post(`${environment.config.apiOrderUrl}payment/createOrder`, {
      "amount":razorPayAmount,
      "mode":"Test Mode" ,
    });

    const options = {
      // key: 'rzp_live_ZepLWVVvssYGcF', // Enter the Key ID generated from Razorpay Dashboard
      key: 'rzp_test_Dk9GIcyaizdBM9',
      amount: result.data.amount,
      currency: "INR",
      name: "Ghoomo World",
      description: "Test Transaction",
      order_id: result.data.id,
      handler: function (response) {
        // alert(`Payment Successful! Payment ID: ${response.razorpay_payment_id}`);
        // Send this response to backend to verify payment

        if (response) {
          inItPayment(result.data.id,response.razorpay_payment_id );
          navigate('/payment-success');
        }
        
      },
      prefill: {
        name: "Your Name",
        email: "email@example.com",
        contact: `${userDetails.mobileNo}`
      },
      theme: {
        color: "#3399cc"
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const inItPayment = (order_id, payment_id) => {
    const modeType = 'Auto';
    const accessToken = localStorage.getItem('accessToken');
    
    const updatedTravellerDetailsList = paymentDetails.travellerDetailsList.map((traveller, travellerIndex) => {
      const updatedAdultDetails = traveller.adultDetails.map((adult, adultIndex) => {
        return {
          ...adult,
          price: paymentDetails.perAdultPriceArray?.[adultIndex] || 0
        };
      });
  
      const updatedChildDetails = traveller.childDOB?.map((child, childIndex) => {
        return {
          ...child,
          price: paymentDetails.perChildPriceArray?.[childIndex] || 0
        };
      }) || []; 
  
      return {
        ...traveller,
        adultDetails: updatedAdultDetails,
        childDOB: updatedChildDetails,
      };
    });
  
    const requestBody = {
      "departureCity": paymentDetails.depCity,
      "departureDate": paymentDetails.formattedDate,
      "customAmount": customAmount,
      "grandTotal": grandTotal,
      "regAmount": regAmount,
      "selectedOption": selectedOption,
      "orderStatus": orderStatus,
      "selectedTrainOption": selectedTrainOption,
      "packageDays":paymentDetails.packageDays,
      "packageNight":paymentDetails.packageNight,
      "termsAccepted": termsAccepted,
      "packageUID": paymentDetails.packageUID,
      "packageName": paymentDetails.packageName,
      "packagePrices": paymentDetails.packagePrices,
      "paymentMode": "Online",
      "paymentId": "N/A",
      "transactionId": payment_id,
      "paymentOrderId": order_id,
      "pendingAmount": pendingAmount.toFixed(2),
      "adultPrices": paymentDetails.perAdultPrice,
      "childPrices": paymentDetails.perChildPrice,
      "token": accessToken,
      "travellerDetailsList": updatedTravellerDetailsList,
      "paidAmount":paidAmount,
      ...(selectedTrainOption === 'AC' && { "acPrice": paymentDetails.acPrice })
    }
    console.log(requestBody)
    axios.post(`${environment.config.apiOrderUrl}order/userId/${userDetails.userId}/orderType/${modeType}/createOrder`, requestBody)
  }

  return (
    // <button onClick={loadRazorpay}>Make Payment</button>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {/* <h2>Razorpay Payment</h2> */}
      {/* <button onClick={loadRazorpay} style={{ padding: "10px 20px" }}>
        Make Payment
      </button> */}
      <button
        className="btn btn-primary"
        onClick={createOrder}
        style={{ backgroundColor: '#fff099', color: '#2d2b29', width: '100%', border: '1px solid #fff099' }}
        disabled={!termsAccepted}
      >
        {termsAccepted
          ? `Make Payment ₹${(totalAmount / 100).toFixed(2)}`
          : `Make Payment ₹${(totalAmount / 100).toFixed(2)}`}
      </button>
    </div>
  );
}

export default MakePayment;
